
import { defineComponent } from 'vue';
import StationsMap from '@/components/Blocks/StationsMap.vue';

export default defineComponent({
  components: {
    StationsMap,
  },
});
